// extracted by mini-css-extract-plugin
export default {"buttons":"LinksListCreate_buttons__6bnLo","link":"LinksListCreate_link__h4j2K","simpleText":"LinksListCreate_simpleText__wBjHC"};